/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { IHeaderViewProps } from '@msdyn365-commerce-modules/header/dist/types/modules/header/header';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IHeaderProps } from '../definition-extensions/header.ext.props.autogenerated';

// tslint:disable-next-line: max-func-body-length
const headerView: React.FC<IHeaderViewProps & IHeaderProps<{}>> = props => {
    const { HeaderTag, HeaderContainer } = props;

    return (
        <Module {...HeaderTag}>
            <Node {...HeaderContainer}>
                {props.logo}
                <div className='ms-header__links'>
                    {props.slots && props.slots.smweMenuBar && _renderReactFragment(props.slots.smweMenuBar)}
                </div>
            </Node>
        </Module>
    );
};

function _renderReactFragment(items: React.ReactNode[]): JSX.Element | null {
    return (
        <React.Fragment>
            {items && items.length
                ? items.map((slot: React.ReactNode, index: number) => {
                        return <React.Fragment key={index}>{slot}</React.Fragment>;
                    })
                : null}
        </React.Fragment>
    );
}

export default headerView;